'use client'

import { VaultRiskCurationLayout } from '../VaultRiskCurationLayout'
import AllocatorDataListLoading from './AllocatorDataListLoading'

const VaultRiskCurationLoading = () => {
  return (
    <VaultRiskCurationLayout>
      <AllocatorDataListLoading />
    </VaultRiskCurationLayout>
  )
}

export default VaultRiskCurationLoading
